<div class="row">
    <!-- Consignment Panel -->
    <div class="col-md-4 col-sm-12">
        <div class="card">
            <div class="card-header px-2 d-flex flex-wrap text-muted justify-content-between align-items-center">
                <h6 class="mb-0">
                    <span class="mr-1">
                        <i [ngClass]="(list1Spinner)? 'fa-spin':'' " class="cursor-pointer fa fa-refresh" title="Refresh this list" aria-hidden="true"
                        (click)="reloadConsignments('consignment')"></i>
                    </span>
                    Consignment Panel
                </h6>

                <h6 class="mb-0 float-right">
                    <span class="float-right ml-2 text-muted text-center" (click)="openSearchModal('consignment')">
                        <i class="cursor-pointer fa fa-filter" title="Filter List" aria-hidden="true"></i>
                    </span>

                    <span id="checkbox" title="Select All" *ngIf="hasConsignmentLeft">
                        <label class="mb-0" title="Select All">
                            <input id="checkbox-element" type="checkbox" (change)="checkAllConsignment($event)" />
                            <i id="all" class="fa fa-th-list cursor-pointer" aria-hidden="true" ></i>
                        </label>  
                    </span>
                </h6>
            </div>
            
            <!-- Consignment Items -->
            <div class="card-body p-0 fixed-card-length">
                <div id="consignmentData" dragula="CONSIGNMENT" [(dragulaModel)]="connotesListing" class="fixed-card-length">
                    <ng-container  *ngIf="connotesListing.length != 0;else noConsignmentList">
                        <ng-container *ngFor="let connote of connotesListing;first as isFirst; last as isLast; let consignmentIndex=index">
                            <div 
                                id="selectedConsignment{{consignmentIndex}}" 
                                [ngClass]="returnConsignmentIndex != null ? 'card-dashed' : ''"
                                class="p-3 card-bottom-border target-consignment item-hover" 
                                (click)="clickConsignmentItem(consignmentIndex)">

                                    <!-- Customer and Ref # -->
                                    <div class="mb-2 d-flex flex-wrap justify-content-between align-items-center font-12">
                                        <div class="text-truncate mr-1">
                                            <span title="{{connote.computed_days_desc}}">
                                                <ng-container *ngIf="connote?.control_no != null">
                                                    <span class="badge badge-pill badge-secondary mr-1"> 
                                                        {{connote.control_no}}
                                                    </span>
                                                </ng-container>
                                                <span *ngIf="connote.computed_days_on_sched == true" class="mr-1" [ngClass]="connote.duration > 0 ? 'text-warning':'text-primary'" >
                                                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                                                </span>
                                            </span>
        
                                            <a *ngIf="isEnabled('Connotes') || isEnabled('Jobs')" href="/bookings/connotes/details/{{connote.id}}" target="_blank" class="font-weight-bold text-muted" title="View {{connote.company_name}}'s details">
                                                <span class="cursor-pointer">{{connote.company_name}}</span> 
                                            </a>
                                            <span *ngIf="!isEnabled('Connotes') && !isEnabled('Jobs')" class="cursor-pointer">{{connote.company_name}}</span>
                                        </div>
                                        <div class="text-muted badge badge-pill badge-light" title="Customer Ref No.: {{connote.customer_reference_no}}" *ngIf="connote.customer_reference_no != null">{{connote.customer_reference_no}}</div>
                                    </div>
                        
                                    <!-- Date and Route-->
                                    <ng-container *ngFor="let location_site of connote.connote_sites; let lastItem=last">
                                    <div class="timeline">
                                        <div class="timeline__line_inner"  *ngIf="!lastItem"></div>
                                        
                                        <ul class="timeline__items">
                                            <li class="timeline__item_inner"> 
                                                <div class="timeline__top text-muted">

                                                    <div class="timeline__circle_active text-center mr-2">
                                                        <i class="fa fa-map-marker icon-top-index font-10" aria-hidden="true"></i>
                                                    </div>

                                                    <div class="timeline__title font-12">
                                                        <div class="font-weight-bold">
                                                            {{ (location_site.run_action ? location_site.run_action : location_site.run_action_label) | titlecase }} on
                                                            {{location_site.opening_datetime | date: 'dd MMM yyyy, h:mm a'}}
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="timeline__desc font-12" *ngIf="location_site.location_id != null;else noConsignmentLocation">
                                                    At <span *ngIf="location_site.company_name != null">{{location_site.company_name}}, </span>
                                                    {{location_site.location_street_no}} {{location_site.location_street}}, {{(location_site.location_city)? location_site.location_city: location_site.location_suburb}}, {{location_site.state_abbrev}}
                                                </div>
                                                <ng-template #noConsignmentLocation>
                                                    Location to be determined
                                                </ng-template>
                                            </li>
                                        </ul>
                                    </div>
                                    </ng-container>

                                    <!-- Freight Details -->
                                    <div class="timeline">
                                        <div class="timeline__line_inner"></div>
                                        
                                        <ul class="timeline__items">
                                            <li class="timeline__item_inner"> 
                                                <div class="timeline__top text-muted">

                                                    <div class="timeline__circle_active text-center mr-2">
                                                        <i class="fa fa-cube icon-top-index font-10" aria-hidden="true"></i>
                                                    </div>

                                                    <div class="list-title font-12" *ngIf="connote.connote_packaging != null && connote.connote_packaging.length != 0;else noFreight">
                                                        <ng-container *ngFor="let pkg of connote.connote_packaging">
                                                            {{pkg.quantity}} 
                                                            <ng-container *ngFor="let type of packaging_types">
                                                                <ng-container *ngIf="type.id == pkg.packaging_type_id"> {{type.name}} </ng-container>
                                                            </ng-container>
                                                            ({{pkg.weight | number: '1.0-2'}} kg) | 
                                                            {{pkg.length | number: '1.0-2'}} x {{pkg.width | number: '1.0-2'}} x {{pkg.height | number: '1.0-2'}} cm per item
                                                            <br>
                                                        </ng-container>
                                                    </div>
                                                    <ng-template #noFreight>
                                                        <div class="list-title font-12">
                                                            <ng-container *ngIf="connote.run_id != undefined;else displayFreightDetails">
                                                                <i class="fa fa-spinner fa-lg fa-spin mr-1"></i>
                                                                <ng-container *ngIf="isReturnedConsignment;else stillReturningConsignment">
                                                                    Fetching returned
                                                                </ng-container>
                                                                <ng-template #stillReturningConsignment>
                                                                    Cancelling dispatch of
                                                                </ng-template>
                                                                 {{connote.control_no}} consignment
                                                            </ng-container>
                                                            <ng-template #displayFreightDetails>
                                                                No freight details provided
                                                            </ng-template>
                                                        </div>
                                                    </ng-template>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
        
                            </div>
                        </ng-container>
                    </ng-container>
                    <ng-template #noConsignmentList>
                        <div class="fixed-card-length card-dashed d-flex align-items-center  justify-content-center">
                            <div class="row">
                                <div class="col-12 py-4 text-center">
                                    <ng-container *ngIf="loadConsignmentSpinner;else provedNoConsignment">
                                        <i class="fa fa-spinner fa-lg fa-spin"></i>
                                        <p class="my-3">Loading consignments...</p>
                                    </ng-container>
                                    <ng-template #provedNoConsignment>
                                        <p class="my-3"> You don't have any consignment left</p>
                                        <button type="button" class="btn btn-outline-primary" routerLink="/bookings/connotesv2">Book a Job</button>
                                    </ng-template>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </div> 
            <!-- end of .card-body -->
        </div>
    </div>
    <!-- End of Consignment Panel -->

    <!-- Edit Consignments -->
    <ng-template #editConsignments>
                    <div class="modal-header">
                        <h5 class="modal-title">Please review the following consignments</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="cancelDispatch()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <form [formGroup]="editConsignmentForm">
                            <div class="modal-body" style="max-height: 500px; overflow-y: auto; overflow-x: hidden;">
                                <div formArrayName="editConsignmentList">
                                <div *ngFor="let connote of connotes_toCheck; let i=index" [formGroupName]="i">
                                    <!-- Customer and Ref # -->
                                    <div class="row">
                                        <div class="col-md-1">
                                            <input type="checkbox" formControlName="checkDone">
                                            <input type="hidden" formControlName="id" [value]="connote.id">
                                        </div>
                                        <div class="col-md">
                                            <div class="mb-2 d-flex flex-wrap justify-content-between align-items-center font-12">
                                                <div class="mr-1">
                                                    <span class="badge badge-pill badge-secondary mr-1"> {{connote.control_no}} </span>
                                                    <span class="cursor-pointer">{{connote.company_name}}</span>
                                                    <div class="text-muted badge badge-pill badge-light" title="Customer Ref No.: {{connote.customer_reference_no}}" *ngIf="connote.customer_reference_no != null"
                                                    style="white-space: pre-line;">
                                                        {{connote.customer_reference_no}}
                                                    </div>
                                                </div>
                                            </div>
                
                                            <!-- Date and Route-->
                                            <ng-container *ngFor="let location_site of connote.connote_sites; let lastItem=last">
                                                <div class="timeline">
                                                    <div class="timeline__line_inner"  *ngIf="!lastItem"></div>
                                                    
                                                    <ul class="timeline__items">
                                                        <li class="timeline__item_inner"> 
                                                            <div class="timeline__top text-muted">
                
                                                                <div class="timeline__circle_active text-center mr-2">
                                                                    <i class="fa fa-map-marker icon-top-index font-10" aria-hidden="true"></i>
                                                                </div>
                
                                                                <div class="timeline__title font-12">
                                                                    <div class="font-weight-bold">
                                                                        {{ (location_site.run_action ? location_site.run_action : location_site.run_action_label) | titlecase }} on
                                                                        {{location_site.opening_datetime | date: 'dd MMM yyyy, h:mm a'}}
                                                                    </div>
                                                                </div>
                                                            </div>
                
                                                            <div class="timeline__desc font-12" *ngIf="location_site.location_id != null;else noConsignmentLocation">
                                                                At <span *ngIf="location_site.company_name != null">{{location_site.company_name}}, </span>
                                                                {{location_site.location_street_no}} {{location_site.location_street}}, {{(location_site.location_city)? location_site.location_city: location_site.location_suburb}}, {{location_site.state_abbrev}}
                                                            </div>
                                                            <ng-template #noConsignmentLocation>
                                                                Location to be determined
                                                            </ng-template>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </ng-container>
                                        </div>
                                        <div class="col-md w-100">
                                            <div class="row">
                                                <h6>Dispatch on:</h6>
                                                <!-- <my-date-picker [options]="myDatePickerOptions" formControlName="editConsignmentDate"></my-date-picker> -->
                                                 <input type="date" class="form-control form-control-sm" formControlName="editConsignmentDate" min="{{minDate|date:'yyyy-MM-dd'}}" value="{{minDate|date:'yyyy-MM-dd'}}">
                                            </div>
                                            <div formArrayName="editConsignmentTimeList">
                                            <div class="row" *ngFor="let connote_site of connote.connote_sites; let j=index" [formGroupName]="j">
                                                <h6>{{connote_site.run_action || connote_site.run_action_label | titlecase}} Time: </h6> <input type="time" formControlName="editConsignmentTime" class="form-control form-control-sm">
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                    <small class="text-danger font-weight-bold d-block text-right" *ngIf="invalidDate.includes(i)"> Please check the date and time</small>
                                    <hr *ngIf="i != connotes_toCheck.length-1">
                                </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <div class="row w-100 align-items-center">
                                    <div class="col-md-1 font-italic">
                                        <small style="white-space: nowrap">{{countCheckedConnotes}} / {{connotes_toCheck.length}} selected</small> <br>
                                        <small style="white-space: nowrap" *ngIf="(selectedConnote.length-connotes_toCheck.length) > 0">{{selectedConnote.length-connotes_toCheck.length}} future dated connote/s</small>
                                    </div>
                                    <div class="col-md text-right">
                                        <button type="submit" class="btn btn-sm btn-success" (click)="saveEditedConsignments()" [disabled]="invalidDate.length>0 || isEditConsignmentDone==false">Save</button>&nbsp;
                                        <button type="button" class="btn btn-sm btn-secondary" (click)="cancelDispatch()">Close</button>
                                    </div>
                                </div>
                            </div>
                    </form>
    </ng-template>
    <!-- End of Edit Consignment -->

    <!-- Carrier Panel -->
    <div class="col-md-4 col-sm-12">
        <div class="card">
            <h6 class="card-header px-2">
                <span class="mr-1">
                    <i [ngClass]="(list2Spinner)? 'fa-spin':'' " class="cursor-pointer fa fa-refresh" title="Refresh this list" aria-hidden="true"
                    (click)="reloadConsignments('carrier')"></i>
                </span>
                Carrier Panel
                <span class="float-right" (click)="openSearchModal('carrier')"><i class="fa fa-filter cursor-pointer" title="Filter List" aria-hidden="true"></i></span>
            </h6>
        
            <!-- Carrier Items -->
            <div class="card-body p-0 fixed-card-length" *ngIf="carrierList.length != 0;else noCarrierList" >
                <div class="accordion carrier-accordion" *ngFor="let carrier of carrierList; trackBy: trackByFn; index as carrierIndex">
                    <div class="card">
                        <div class="card-header card-header-bg p-3">
                            <!-- Driver and Paired Fleet Header -->
                            <a data-toggle="collapse" href="#collapseCarrier{{carrierIndex}}" aria-expanded="true"
                                aria-controls="collapseCarrier" class="btn-nav-accordion collapsed">

                                <div class="mb-0 d-flex flex-wrap justify-content-between align-items-center">
                                    <div class="font-12 font-weight-bold">
                                        <i class="fa fa-chevron-up text-primary"></i>

                                        <span class="badge badge-pill badge-primary mx-1">
                                            <ng-container *ngIf="carrier.currentManifest_id == null;else withToDo">
                                                <span title="Dispatch a job to {{carrier.first_name}}">Idle</span>
                                            </ng-container>
                                            <ng-template #withToDo>
                                                <span title="{{carrier.full_job_status_desc}}">{{ carrier.full_job_status }}</span>
                                            </ng-template>
                                        </span>

                                        <span (click)="viewDriver(carrier.id)" class="text-muted text-truncate font-12" title="View {{carrier.first_name | titlecase }} {{carrier.last_name | titlecase }}'s details">
                                            <span class="cursor-pointer">{{carrier.first_name | titlecase }} {{carrier.last_name | titlecase }}</span>
                                        </span>
                                    </div>

                                    <div class="font-12">
                                        <span class="badge badge-pill badge-light text-muted" title="Registered Vehicle: {{carrier.equipment[0].fleet_id_num}}">
                                            {{carrier.equipment[0].fleet_type_name | uppercase }} 
                                            <ng-container *ngIf="carrier.equipment[0].fleet_subtype_name != null"> - </ng-container> 
                                            {{carrier.equipment[0].fleet_subtype_name | uppercase }}
                                        </span>
                                    </div>
                                </div>
                            </a>
                        </div>
    
                        <!-- Carrier Tasks -->
                        <div id="collapseCarrier{{carrierIndex}}" class="collapse" aria-labelledby="headingCarrier">
                            <div [attr.id]="carrierIndex" class="card-body p-0" >
                                <div id="carrierContentData" class="target-carrier" dragula="CONSIGNMENT" [(dragulaModel)]="carrierList[carrierIndex].assignedConnotes">
                                    <!-- For new dispatch-->
                                    <div class="card-dashed" *ngIf="carrierList[carrierIndex].is_dispatching;else dispatchingConnote">
                                        <div class="p-3">
                                            <div class="font-11 d-flex align-items-center justify-content-center" style="height: 57px;">
                                                <i class="fa fa-spinner fa-lg fa-spin mr-2"></i>
                                                <p class="my-3">Dispatching consignment...</p>
                                            </div>
                                        </div>
                                    </div>
                                    <ng-template #dispatchingConnote>
                                        <ng-container *ngIf="carrier.assignedConnotes.length != 0;else noTask">
                                            <ng-container *ngFor="let task of carrier.assignedConnotes; let taskIndex=index">
                                                <div class="p-3 card-bottom-border" [ngClass]="{'card-dashed': task?.hasActivitiesDone == true, 'card-disable': isReturnedConsignment}">
                                                    <!-- Connote #, Status, Customer, and Ref # --> 
                                                    <div class="mb-2 d-flex flex-wrap justify-content-between align-items-center font-12">
                                                        <div class="text-truncate mr-1">

                                                            <!-- Connote # -->
                                                            <ng-container *ngIf="task.control_no != null">
                                                                <span class="badge badge-pill badge-secondary mr-1"> 
                                                                    {{task.control_no}}
                                                                </span>
                                                            </ng-container>
        
                                                            <!-- Connote Status -->
                                                            <i *ngIf="task.run_status_id != 4 && task.hasActivitiesDone" class="fa fa-check-circle-o text-primary mr-1" aria-hidden="true" title="In Transit"></i>
                                                            <i *ngIf="task.run_status_id == 4" class="fa fa-check-circle text-success mr-1" aria-hidden="true" title="Delivered"></i>

                                                            <!-- Customer Name -->
                                                            <a *ngIf="isEnabled('Jobs') || isEnabled('Connotes')" href="/bookings/connotes/details/{{task.id}}" target="_blank" class="font-weight-bold text-muted mr-1" title="View {{task.customer}}'s details">
                                                                <span class="cursor-pointer">{{task.customer}}</span> 
                                                            </a>
                                                            <span *ngIf="!isEnabled('Jobs') && !isEnabled('Connotes')" class="cursor-pointer">{{task.customer}}</span> 
                                                        </div>

                                                        <!-- Ref # -->
                                                        <div class="text-muted badge badge-pill badge-light" title="Customer Ref No.: {{task.customer_reference_no}}" *ngIf="task.customer_reference_no != null">{{task.customer_reference_no}}</div>
                                                    </div>
                                        
                                                    <!-- Date and Route -->
                                                    <ng-container *ngFor="let location_site of task.activities; let lastItem=last">
                                                        <div class="timeline">
                                                            <div class="timeline__line_inner"  *ngIf="!lastItem"></div>
                                                            
                                                            <ul class="timeline__items">
                                                                <li class="timeline__item_inner"> 
                                                                    <div class="timeline__top text-muted">
                    
                                                                        <div class="timeline__circle_active text-center mr-2">
                                                                            <i class="fa fa-map-marker icon-top-index font-10" aria-hidden="true"></i>
                                                                        </div>
                    
                                                                        <div class="timeline__title font-12">
                                                                            <div class="font-weight-bold">
                                                                                {{ (location_site.run_action ? location_site.run_action : location_site.run_action_label) | titlecase }} on
                                                                                {{location_site.start_datetime | date: 'dd MMM yyyy, h:mm a'}}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                    
                                                                    <div class="timeline__desc font-12" *ngIf="location_site.location_id != null;else noConsignmentLocation">
                                                                        At <span *ngIf="location_site.company_name != null">{{location_site.company_name}}, </span>
                                                                        {{location_site.street_no}} {{location_site.street}}, {{(location_site.city)? location_site.city: location_site.suburb}}, {{location_site.state_abbrev}}
                                                                    </div>
                                                                    <ng-template #noConsignmentLocation>
                                                                        Location to be determined
                                                                    </ng-template>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </ng-container>

                                                    <!-- Freight Details -->
                                                    <div class="timeline">
                                                        <div class="timeline__line_inner"></div>
                                                        
                                                        <ul class="timeline__items">
                                                            <li class="timeline__item_inner"> 
                                                                <div class="timeline__top text-muted">

                                                                    <div class="timeline__circle_active text-center mr-2">
                                                                        <i class="fa fa-cube icon-top-index font-10" aria-hidden="true"></i>
                                                                    </div>

                                                                    <div class="list-title font-12" *ngIf="task.connote_packaging != null && task.connote_packaging.length != 0;else noFreight2">
                                                                        <ng-container *ngFor="let pkg of task.packagings">
                                                                            {{pkg.quantity}} 
                                                                            <ng-container *ngFor="let type of packaging_types">
                                                                                <ng-container *ngIf="type.id == pkg.packaging_type_id"> {{pkg.packaging_type}} </ng-container>
                                                                            </ng-container>
                                                                            ({{pkg.weight | number: '1.0-2'}} kg) | 
                                                                            {{pkg.length | number: '1.0-2'}} x {{pkg.width | number: '1.0-2'}} x {{pkg.height | number: '1.0-2'}} cm per item
                                                                            <br>
                                                                        </ng-container>
                                                                    </div>
                                                                    <ng-template #noFreight2>
                                                                        <div class="list-title font-12">
                                                                            <ng-container *ngIf="carrierList[carrierIndex].is_updating;else displayFreightDetails2">
                                                                                <i class="fa fa-spinner fa-lg fa-spin mr-1"></i>
                                                                                Dispatching {{task.control_no}} consignment
                                                                            </ng-container>
                                                                            <ng-template #displayFreightDetails2>
                                                                                No freight details provided
                                                                            </ng-template>
                                                                        </div>
                                                                    </ng-template>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>

                                                </div>
                                            </ng-container>
                                        </ng-container>
                                        <ng-template #noTask>
                                                <div class="card-dashed font-12 d-flex align-items-center justify-content-center my-3" style="height: 57px;">
                                                    Drag a consignment item here
                                                </div>
                                        </ng-template>
                                    </ng-template>
                                </div>
                            </div>
                        </div> 
                        <!-- end of .collapse .show -->
    
                    </div>
                </div>
            </div>
            <ng-template #noCarrierList>
                <div class="card-body fixed-card-length d-flex align-items-center justify-content-center">
                    <div class="row">
                        <div class="col-12 py-4 text-center">
                            <ng-container *ngIf="loadCarrierSpinner;else provedNoCarrier">
                                <i class="fa fa-spinner fa-lg fa-spin"></i>
                                <p class="my-3">Loading drivers...</p>
                            </ng-container>
                            <ng-template #provedNoCarrier>
                                <p class="my-3"> You don't have any available drivers</p>
                                <button type="button" class="btn btn-outline-primary" routerLink="/drivers/driverslist" *ngIf="isEnabled('Drivers')">See All Drivers</button>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
    <!-- End of Carrier Panel -->

    <!-- Manifest Panel -->
    <div class="col-md-4 col-sm-12">
        <div class="card">
            <h6 class="card-header px-2">
                <i [ngClass]="(list3Spinner)? 'fa-spin':'' " class="fa fa-refresh ml-2 cursor-pointer"  title="Refresh this List" aria-hidden="true"
                (click)="reloadConsignments('manifest')"></i>&nbsp;
                 Manifest Panel 
                <span class="float-right">
                    <!-- start of single date picker -->
                    <span>
                        <button [disabled]="loadCarrierSpinner" style="border-radius:50%;" [ngClass]="(singleDate)?'btn btn-success btn-sm':'btn btn-secondary btn-sm'" title="single date picker" (click)="toggleSingleDatePicker()"><i [ngClass]="(singleDate)?'fa fa-chevron-right':'fa fa-chevron-left'" aria-hidden="true"></i></button>
                        <input type="text" width="100" class="dateRangeInput ml-1" [hidden]="!singleDate"  matInput
                            ngxDaterangepickerMd  startKey="start" endKey="end" [(ngModel)]="jobDateRange" (ngModelChange)="processDateRange()"
                            name="daterange" [autoApply]="true" [closeOnAutoApply]="true" opens="left" drops="down" [singleDatePicker]="true"/>
                    </span>
                    <!-- end of single date picker -->
                    <span>
                        <!-- start of date filters -->
                        <select [disabled]="loadCarrierSpinner" id="dateFilters" [(ngModel)]="dateFilter" (ngModelChange)="onChangeDateDropdown($event)" class="ml-1 text-muted badge badge-pill badge-light" (click)="toggleCalendar()">
                            <option value="all">All dates</option>
                            <option value="today">Today</option>
                            <option value="week">This Week</option>
                            <option value="month">This Month</option>
                            <option value="year">This Year</option>
                            <option value="7">Last 7 days</option>
                            <option value="14">Last 14 days</option>
                            <option value="30">Last 30 days</option>
                            <option value="60">Last 60 days</option>
                            <option value="90">Last 90 days</option>
                            <option value="range" id="date_range_label">Custom date range</option>
                        </select> &nbsp;
                        <!-- end of date filters -->
                        <span (click)="openSearchModal('manifest')">
                            <i class="fa fa-filter cursor-pointer"  title="Filter List" aria-hidden="true"></i>
                        </span>
                    </span>
                </span>
                <span *ngIf="toggleDateRangePicker()" class="ml-0 pl-0">&nbsp;
                    <input type="text" width="100" class="mb-1 ml-0" class="dateRangeInput" matInput
                        ngxDaterangepickerMd  startKey="start" endKey="end" [(ngModel)]="jobDateRange" (ngModelChange)="processDateRange()"
                        name="daterange" [autoApply]="true" opens="left" drops="down"/>
                </span>
            </h6>
        
            <!-- Manifest Item -->
            <div class="card-body p-0 fixed-card-length" *ngIf="manifestList.length != 0;else noManifestList">
                <ng-container *ngFor="let manifest of manifestList;let i=index">
                    <div id="accordionManifest" role="tablist" class="accordion">
                        <div class="card">
                            <div class="card-header card-header-bg p-3" id="headingOne">
                                <a data-toggle="collapse" href="#collapseManifest{{i}}" aria-expanded="true"
                                aria-controls="collapseManifest" class="btn-nav-accordion collapsed">

                                <!-- Manifest # and Status -->
                                <div class="text-muted mb-1 d-flex flex-wrap justify-content-between align-items-center">
                                        <div class="font-12 font-weight-bold">
                                            <i class="fa fa-chevron-up text-primary"></i>

                                            <span class="badge badge-pill badge-primary mx-1">
                                                {{(manifest.sub_status)?manifest.sub_status:manifest.run_status}}
                                            </span>

                                            <span class="cursor-pointer" (click)="viewManifest(manifest.id)" title="View {{manifest.control_no}}'s' details">{{manifest.control_no}}</span>
                                        </div>

                                        <div class="font-12">
                                            <ng-container *ngFor="let drv of manifest.drivers; let lastItem = last;">
                                                <span class="text-muted badge badge-pill badge-light">
                                                    {{drv.first_name | uppercase}} {{drv.last_name| uppercase}}
                                                </span>
                                                <span *ngIf="!lastItem">, </span>
                                            </ng-container>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <!-- end of .card-header -->
            
                            <!-- Manifest Content -->
                            <div id="collapseManifest{{i}}" class="collapse" aria-labelledby="headingOne" role="tabpanel" 
                                data-parent="#accordionManifest">
                                <div class="card-body p-0">
                                    <div class="p-3 card-bottom-border" *ngFor="let connote of manifest.connotes">
                                        <!-- Connote #, Status, Customer, and Ref # -->
                                        <div class="mb-2 d-flex flex-wrap justify-content-between align-items-center font-12">
                                            <div class="text-truncate mr-1">

                                                <!-- Connote # -->
                                                <ng-container *ngIf="connote.control_no != null">
                                                    <span class="badge badge-pill badge-secondary mr-1"> 
                                                        {{connote.control_no}}
                                                    </span>
                                                </ng-container>

                                                <!-- Connote Status -->
                                                <i *ngIf="connote.run_status_id != 4 && connote.hasActivitiesDone == true" class="fa fa-check-circle-o text-primary mr-1" aria-hidden="true" title="In Transit"></i>
                                                <i *ngIf="connote.run_status_id == 4" class="fa fa-check-circle text-success mr-1" aria-hidden="true" title="Delivered"></i>

                                                <!-- Customer Name -->
                                                <a *ngIf="isEnabled('Jobs') || isEnabled('Connotes')" href="/bookings/connotes/details/{{connote.id}}" target="_blank" class="font-weight-bold text-muted mr-1" title="View {{connote.customer}}'s details">
                                                    <span class="cursor-pointer">{{connote.customer}}</span> 
                                                </a>
                                                <span class="cursor-pointer" *ngIf="!isEnabled('Jobs') && !isEnabled('Connotes')">{{connote.customer}}</span> 

                                            </div>

                                            <!-- Ref # -->
                                            <div class="text-muted badge badge-pill badge-light" title="Customer Ref No.: {{connote.customer_reference_no}}" *ngIf="connote.customer_reference_no != null">{{connote.customer_reference_no}}</div>
                                        </div>

                                        <!-- Date and Route -->
                                        <ng-container *ngFor="let location_site of connote.activities; let lastItem=last">
                                            <div class="timeline">
                                                <div class="timeline__line_inner"  *ngIf="!lastItem"></div>
                                                
                                                <ul class="timeline__items">
                                                    <li class="timeline__item_inner"> 
                                                        <div class="timeline__top text-muted">
        
                                                            <div class="timeline__circle_active text-center mr-2">
                                                                <i class="fa fa-map-marker icon-top-index font-10" aria-hidden="true"></i>
                                                            </div>
        
                                                            <div class="timeline__title font-12">
                                                                <div class="font-weight-bold">
                                                                    {{ (location_site.run_action ? location_site.run_action : location_site.run_action_label) | titlecase }} on
                                                                    {{location_site.start_datetime | date: 'dd MMM yyyy, h:mm a'}}
                                                                </div>
                                                            </div>
                                                        </div>
        
                                                        <div class="timeline__desc font-12" *ngIf="location_site.location_id != null;else noConsignmentLocation">
                                                            At <span *ngIf="location_site.company_name !=null">{{location_site.company_name}}, </span>
                                                            {{location_site.street_no}} {{location_site.street}}, {{(location_site.city)? location_site.city: location_site.suburb}}, {{location_site.state_abbrev}}
                                                        </div>
                                                        <ng-template #noConsignmentLocation>
                                                            Location to be determined
                                                        </ng-template>
                                                    </li>
                                                </ul>
                                            </div>
                                        </ng-container>

                                        <!-- Freight Details -->
                                        <div class="timeline">
                                            <div class="timeline__line_inner"></div>
                                            
                                            <ul class="timeline__items">
                                                <li class="timeline__item_inner"> 
                                                    <div class="timeline__top text-muted">

                                                        <div class="timeline__circle_active text-center mr-2">
                                                            <i class="fa fa-cube icon-top-index font-10" aria-hidden="true"></i>
                                                        </div>

                                                        <div class="list-title font-12" *ngIf="connote.packagings != null && connote.packagings.length != 0;else noFreight2">
                                                            <ng-container *ngFor="let pkg of connote.packagings">
                                                                {{pkg.quantity}} 
                                                                <ng-container *ngFor="let type of packaging_types">
                                                                    <ng-container *ngIf="type.id == pkg.packaging_type_id"> {{pkg.packaging_type}} </ng-container>
                                                                </ng-container>
                                                                ({{pkg.weight | number: '1.0-2'}} kg) | 
                                                                {{pkg.length | number: '1.0-2'}} x {{pkg.width | number: '1.0-2'}} x {{pkg.height | number: '1.0-2'}} cm per item
                                                                <br>
                                                            </ng-container>
                                                        </div>
                                                        <ng-template #noFreight2>
                                                            <div class="list-title font-12">
                                                                No freight details provided
                                                            </div>
                                                        </ng-template>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div> 
                            <!-- end of .collapse .show -->
            
                        </div>
                    </div>
                </ng-container>
            </div>
            <ng-template #noManifestList>
                <div class="card-body fixed-card-length d-flex align-items-center justify-content-center">
                    <div class="row">
                        <div class="col-12 py-4 text-center">
                            <ng-container *ngIf="loadManifestSpinner;else provedNoManifest">
                                <i class="fa fa-spinner fa-lg fa-spin"></i>
                                <p class="my-3">Loading manifest...</p>
                            </ng-container>
                            <ng-template #provedNoManifest>
                                <p class="my-3"> You don't have any job dispatched</p>
                                <button type="button" class="btn btn-outline-primary" routerLink="/dispatch/local-manifest" target="_blank" *ngIf="isEnabled('Local Manifest')">See All Manifest</button>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
    <!-- End of Manifest Panel -->
</div>

<!-- Consignment, Carrier, and Manifest Panel Modal -->
<ng-template #filterModal let-close="close">
    <div class="modal-header">
        <h5 class="modal-title">Filter {{panelModal | titlecase }} Panel</h5>
        <button type="button" class="close" (click)="close()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div [formGroup]="filterForm" class="modal-body">
        <!-- Manifest Filter -->
        <ng-container *ngIf="panelModal == 'manifest'">
            <div class="form-group row">
                <label class="col-sm-2 col-form-label font-12">Control No.</label>
                <div class="col-sm-10">
                  <input type="text" class="form-control form-control-sm" formControlName="manifest_controlNo" placeholder="Enter Control Number">
                </div>
            </div>
            <div class="form-group row">
            <label class="col-sm-2 col-form-label font-12">Customer</label>
            <div class="col-sm-10">
                <input type="text" class="form-control form-control-sm" formControlName="manifest_customer" placeholder="Enter name of customer">
            </div>
            </div>
            <div class="form-group row">
            <label class="col-sm-2 col-form-label font-12">Order Type</label>
            <div class="col-sm-10"> 
                <button type="button" (click)="setOrderType(ORDER_TYPES_LABEL.ALL)"
                class="btn btn-sm btn-rounded btn-secondary w-100p mb-1 ml-1"
                [class.btn-secondary]="getOrderType() !== ORDER_TYPES_LABEL.ALL" 
                [class.btn-success]="getOrderType() === ORDER_TYPES_LABEL.ALL">
                {{ORDER_TYPES_LABEL.ALL}}
            </button>
            <button type="button" (click)="setOrderType(ORDER_TYPES_LABEL.PURCHASEORD)"
                class="btn btn-sm btn-rounded btn-secondary w-150p mb-1 ml-2"
                [class.btn-secondary]="getOrderType() !== ORDER_TYPES_LABEL.PURCHASEORD" 
                [class.btn-success]="getOrderType() === ORDER_TYPES_LABEL.PURCHASEORD">
                {{ORDER_TYPES_LABEL.PURCHASEORD}}
            </button>
            <button type="button" (click)="setOrderType(ORDER_TYPES_LABEL.SALESORD)"
                class="btn btn-sm btn-rounded btn-secondary w-100p mb-1 ml-2"
                [class.btn-secondary]="getOrderType() !== ORDER_TYPES_LABEL.SALESORD" 
                [class.btn-success]="getOrderType() === ORDER_TYPES_LABEL.SALESORD">
                {{ORDER_TYPES_LABEL.SALESORD}}
            </button>
            </div>
            
            </div>
            <div class="form-group row">
            <label class="col-sm-2 col-form-label font-12">Warehouse</label>
            <div class="col-sm-10">
                    <select class="form-control form-control-sm" formControlName="manifest_warehouse">
                    <option value="0">n/a</option>
                        <option *ngFor="let wh of wh_sites" [value]="wh.id">{{wh?.name}} [{{wh?.street_no}} {{wh?.street}}, {{(wh.city!=null)? wh?.city: wh?.suburb}}, {{wh?.state_abbrev}} {{wh?.postal_code}}]</option>
                    </select>
            </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-2 col-form-label font-12">Manifest Status</label>
            <div class="col-sm-10">
                    <select class="form-control form-control-sm" formControlName="manifest_status">
                        <option *ngFor="let st of subStatuses" [value]="st.id">{{st.name}}</option>
                    </select>
            </div>
            </div>
        </ng-container>
        <!-- Manifest Filter End-->

        <!-- Carrier Filter -->
        <ng-container *ngIf="panelModal == 'carrier'">
            <div class="form-group row">
                <label class="col-sm-2 col-form-label font-12">Status</label>
                <div class="col-sm-10"> 
                    <button type="button" (click)="setCarrierStatus('All')"
                        class="btn btn-sm btn-rounded btn-secondary w-150p mb-1 ml-1"
                        [class.btn-secondary]="getCarrierStatus() !== 'All'" 
                        [class.btn-success]="getCarrierStatus() === 'All'">
                        All
                    </button>
                    <button type="button" (click)="setCarrierStatus('WithJobs')"
                        class="btn btn-sm btn-rounded btn-secondary w-150p mb-1 ml-1"
                        [class.btn-secondary]="getCarrierStatus() !== 'WithJobs'" 
                        [class.btn-success]="getCarrierStatus() === 'WithJobs'">
                        With Ongoing Jobs
                    </button>
                    <button type="button" (click)="setCarrierStatus('WithoutJobs')"
                        class="btn btn-sm btn-rounded btn-secondary w-150p mb-1 ml-1"
                        [class.btn-secondary]="getCarrierStatus() !== 'WithoutJobs'" 
                        [class.btn-success]="getCarrierStatus() === 'WithoutJobs'">
                        Without Ongoing Jobs
                    </button>
                </div>   
            </div>
            <div class="form-group row">
                <label class="col-sm-2 col-form-label font-12">Carrier</label>
                <div class="col-sm-10">
                    <!-- (keyup)="onChangeCustomerName(panelModal, carrierName)" -->
                  <input type="text" class="form-control form-control-sm" formControlName="carrier_name" placeholder="Enter name of carrier">
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-2 col-form-label font-12">Control No.</label>
                <div class="col-sm-10">
                  <input type="text" class="form-control form-control-sm" formControlName="carrier_controlNo" placeholder="Enter Connote Control Number">
                </div>
            </div>

            <div class="form-group row">
                <label class="col-sm-2 col-form-label font-12">Driver Standard</label>
                <div class="col-sm-10">
                    <select class="form-control form-control-sm" formControlName="carrier_DrvStandard">
                    <option value="0">All</option>
                        <option *ngFor="let st of driverStandards" [value]="st.id">{{st?.name}}</option>
                    </select>
                </div>
            </div>

                <div class="form-group row" *ngIf="getCarrierStatus() === 'WithJobs'">
                    <label class="col-sm-2 col-form-label font-12">Order Type</label>
                    <div class="col-sm-10"> 
                        <button type="button" (click)="setOrderType(ORDER_TYPES_LABEL.ALL)"
                        class="btn btn-sm btn-rounded btn-secondary w-100p mb-1 ml-1"
                        [class.btn-secondary]="getOrderType() !== ORDER_TYPES_LABEL.ALL" 
                        [class.btn-success]="getOrderType() === ORDER_TYPES_LABEL.ALL">
                        {{ORDER_TYPES_LABEL.ALL}}
                    </button>
                    <button type="button" (click)="setOrderType(ORDER_TYPES_LABEL.PURCHASEORD)"
                        class="btn btn-sm btn-rounded btn-secondary w-150p mb-1 ml-2"
                        [class.btn-secondary]="getOrderType() !== ORDER_TYPES_LABEL.PURCHASEORD" 
                        [class.btn-success]="getOrderType() === ORDER_TYPES_LABEL.PURCHASEORD">
                        {{ORDER_TYPES_LABEL.PURCHASEORD}}
                    </button>
                    <button type="button" (click)="setOrderType(ORDER_TYPES_LABEL.SALESORD)"
                        class="btn btn-sm btn-rounded btn-secondary w-100p mb-1 ml-2"
                        [class.btn-secondary]="getOrderType() !== ORDER_TYPES_LABEL.SALESORD" 
                        [class.btn-success]="getOrderType() === ORDER_TYPES_LABEL.SALESORD">
                        {{ORDER_TYPES_LABEL.SALESORD}}
                    </button>
                    </div>
                    
                </div>
                <div class="form-group row" *ngIf="getCarrierStatus() === 'WithJobs'">
                    <label class="col-sm-2 col-form-label font-12">Warehouse</label>
                    <div class="col-sm-10">
                        <select class="form-control form-control-sm" formControlName="carrier_warehouse">
                        <option value="0">n/a</option>
                            <option *ngFor="let wh of wh_sites" [value]="wh.id">{{wh?.name}} [{{wh?.street_no}} {{wh?.street}}, {{(wh.city!=null)? wh?.city: wh?.suburb}}, {{wh?.state_abbrev}} {{wh?.postal_code}}]</option>
                        </select>
                    </div>
                </div>
        </ng-container>
        <!-- Carrier Filter End -->
       
        <!-- Consignment Filter -->
        <ng-container *ngIf="panelModal == 'consignment'">
            <div class="form-group row">
                <label class="col-sm-2 col-form-label font-12">Control No.</label>
                <div class="col-sm-10">
                  <input type="text" class="form-control form-control-sm" formControlName="connote_controlNo" placeholder="Enter Control Number">
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-2 col-form-label font-12">Customer</label>
                <div class="col-sm-10">
                    <input type="text" class="form-control form-control-sm" formControlName="connote_customer" placeholder="Enter name of customer">
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-2 col-form-label font-12">Reference No.</label>
                <div class="col-sm-10">
                    <input type="text" class="form-control form-control-sm" formControlName="connote_referenceNo" placeholder="Enter customer reference number">
                </div>
            </div>
            <div class="form-group row">
                <label class="col-sm-2 col-form-label font-12">Order Type</label>
                <div class="col-sm-10"> 
                    <button type="button" (click)="setOrderType(ORDER_TYPES_LABEL.ALL)"
                    class="btn btn-sm btn-rounded btn-secondary w-100p mb-1 ml-1"
                    [class.btn-secondary]="getOrderType() !== ORDER_TYPES_LABEL.ALL" 
                    [class.btn-success]="getOrderType() === ORDER_TYPES_LABEL.ALL">
                    {{ORDER_TYPES_LABEL.ALL}}
                </button>
                <button type="button" (click)="setOrderType(ORDER_TYPES_LABEL.PURCHASEORD)"
                    class="btn btn-sm btn-rounded btn-secondary w-150p mb-1 ml-2"
                    [class.btn-secondary]="getOrderType() !== ORDER_TYPES_LABEL.PURCHASEORD" 
                    [class.btn-success]="getOrderType() === ORDER_TYPES_LABEL.PURCHASEORD">
                    {{ORDER_TYPES_LABEL.PURCHASEORD}}
                </button>
                <button type="button" (click)="setOrderType(ORDER_TYPES_LABEL.SALESORD)"
                    class="btn btn-sm btn-rounded btn-secondary w-100p mb-1 ml-2"
                    [class.btn-secondary]="getOrderType() !== ORDER_TYPES_LABEL.SALESORD" 
                    [class.btn-success]="getOrderType() === ORDER_TYPES_LABEL.SALESORD">
                    {{ORDER_TYPES_LABEL.SALESORD}}
                </button>
                </div>
                
                </div>
            <div class="form-group row">
                <label class="col-sm-2 col-form-label font-12">Warehouse</label>
                <div class="col-sm-10">
                    <select class="form-control form-control-sm" formControlName="connote_warehouse">
                    <option value="0">n/a</option>
                        <option *ngFor="let wh of wh_sites" [value]="wh.id">{{wh?.name}} [{{wh?.street_no}} {{wh?.street}}, {{(wh.city!=null)? wh?.city: wh?.suburb}}, {{wh?.state_abbrev}} {{wh?.postal_code}}]</option>
                    </select>
                </div>
            </div>
        </ng-container>
        <!-- Consignment Filter End-->

    </div>
    <div class="modal-footer">
        <button (click)="resetFilters(panelModal)" type="submit" class="btn btn-sm btn-success">Reset Filter</button>
        <button (click)="searchFilters(filterForm.value)" type="submit" class="btn btn-sm btn-success">Search</button>
    </div>
</ng-template>